import ropsPatch from '@/assets/units/1rops.png';

/**
 * Unit emblem registry: maps a profile emblem key to its patch asset.
 * Data-driven — a new unit gets its patch by dropping an asset here and setting
 * the key on its profile; components never reference a specific unit.
 */
const UNIT_EMBLEMS: Record<string, string> = {
  '1rops': ropsPatch,
};

/** Resolve an emblem key to its asset URL, or null when unknown/absent. */
export function resolveEmblem(key?: string | null): string | null {
  if (!key) return null;
  return UNIT_EMBLEMS[key] ?? null;
}
